export function format(amount, options)
{
	const withCurrency = options?.withCurrency ?? true;

	let formatOptions = {};

	if (withCurrency)
	{
		formatOptions.style = 'currency';
		formatOptions.currency = 'EUR';
	}

	return new Intl.NumberFormat('de-DE', formatOptions)
		.format(amount);
}
